import { ChangeEvent, useCallback, useEffect, useMemo, useRef, useState } from "react";
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { validateString } from "src/utils/string/stringUtil";
import { showSuccess, ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
import { getKSK2120_R01List, patchKSK2120_R01, postKSK2120_R01, } from "./Api_KSK2120_R01";
import { defaultKSK2120_R01Dto, KSK2120_R01Dto } from "./Dto_KSK2120_R01";
import { defaultKSK2120_R01Filter, KSK2120_R01Filter, useKSK2120_R01Store } from "./Store_KSK2120_R01";
import { AgGridReact } from "ag-grid-react";
import { fetchDataSetHandler, fetchDataSetHandler_refetch, fetchFilterConfig, InsertRowHandler, UpdateRowHandler } from "src/utils/grid/GridHandlerContent";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { validateEmployeeCd } from "src/utils/grid/GridValidateContent";
import useUiuxStore, { ProductMaterialNavigationData } from "src/store/useUiuxStore";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";


interface OrderContentProps {
	gridRef: React.RefObject<AgGridReact<KSK2120_R01Dto> | null>;
	setMessage: (message: string) => void;  
	
}	


export const Content_KSK2120_R01 = (props: OrderContentProps) => {

	const { 
		gridRef,
		setMessage,
	} = props;

	const {
		KSK2120_R01Filter, setKSK2120_R01Filter,
		KSK2120_R01PastFilter, setKSK2120_R01PastFilter,
		KSK2120_R01List, setKSK2120_R01List, 
		insertKSK2120_R01List, removeKSK2120_R01List,
		deletedKSK2120_R01List, addDeletedKSK2120_R01List, removeDeletedKSK2120_R01List,
		selectedKSK2120_R01List, setSelectedKSK2120_R01List, removeSelectedKSK2120_R01List,
		originalKSK2120_R01List, setOriginalKSK2120_R01List,
		allCount, setAllCount,
		initData,
	} = useKSK2120_R01Store();

	const { setCodeSearchModalProps, productMaterialNavigationData, setProductMaterialNavigationData } = useUiuxStore();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { compCdList, employeeCdList, jobTeamList, ordTypeList, workPlaceList, } = useCommonCodeStore();

	const [clickable, setClickable] = useState(true);
	
	const navigationDataRef = useRef<ProductMaterialNavigationData | null>(null);
	const [productMaterialTrigger, setProductMaterialTrigger] = useState(false);
	
	const nowWorkNoHandleFoucsId = 'nowWorkNo_search';

	const setAuth = useActionbarAuthStore((state) => state.setAuth);

	// 권한 정보 로드
	useFetchActionbarAuth("KSK2120_R01");

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'nowWorkNo',
			category: '현재공정',
			focusId: nowWorkNoHandleFoucsId,
			responseMapping: {
				productWorkNo: 'nowWorkNo',
			},
			extraFilter: () => ({
				nowWorkNo: KSK2120_R01Filter.nowWorkNo || '',
			}),
			onAfterConfirm: (updatedFields) => {
				fetchData(updatedFields);
			},
		},
	];

	// input form 팝업 열기 이벤트 핸들러
	const { getFieldHandlers: getProductMaterialFieldHandlers } = useInfoFormEvents({
		editData: KSK2120_R01Filter,
		setEditData: setKSK2120_R01Filter,
		defaultData: defaultKSK2120_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2120_R01_search'
	});

	const getParams = (filter: Partial<KSK2120_R01Filter>) => {
		return {
			// pastWorkNo: filter.pastWorkNo,
			nowWorkNo: filter.nowWorkNo,
			pastInfoFetch: filter.pastInfoFetch,
		}
	}

	const executeDataFetch = useCallback(async (fetchType: 'search' | 'refetch', updatedFields?: Partial<KSK2120_R01Filter>) => {
		setLoadingSpinner(true);
		const targetFilter = updatedFields ? { ...KSK2120_R01Filter, ...updatedFields } : KSK2120_R01Filter;

		// if(!validateString(targetFilter.pastWorkNo || '')) { 
		// 	showWarning("과거 공정지시번호를 선택해주세요.");
		// 	setLoadingSpinner(false);
		// 	return;
		// }
		if(!validateString(targetFilter.nowWorkNo || '')) { 
			showWarning("현재 공정지시번호를 선택해주세요.");
			getProductMaterialFieldHandlers('nowWorkNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
			setLoadingSpinner(false);
			return;
		}
		try {
			let initialListLength = KSK2120_R01List.length;
			// 저장 후 재조회 시에는 목록을 비우기.
			if (fetchType === 'refetch') {
				setKSK2120_R01List([]);
			}

		const responseData = await getKSK2120_R01List(
			'',
			getParams(targetFilter),
			fetchType === 'refetch' ? initialListLength : KSK2120_R01List.length ?? 0
		);

		if(!responseData.data.data) {
			showWarning('조회된 데이터가 없습니다.');
			getProductMaterialFieldHandlers('nowWorkNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: targetFilter.nowWorkNo } } as unknown as React.MouseEvent<HTMLInputElement>);
			setLoadingSpinner(false);
			return;
		}

		if (!responseData.data.successFlag) {
			setMessage(responseData.data.message || '조회 중 오류가 발생했습니다.');
			setKSK2120_R01List([]);
			return;
		}
	
		let newList = [...responseData.data.data ] as KSK2120_R01Dto[];
			setKSK2120_R01List(newList);
		
			const processAllCount = newList.length;
			setOriginalKSK2120_R01List(newList);
			setSelectedKSK2120_R01List([]);
			removeDeletedKSK2120_R01List(deletedKSK2120_R01List);
			gridRef.current?.api.ensureIndexVisible(0, 'top');
		
			if (newList.length === 0) {
				insertKSK2120_R01List([{ ...defaultKSK2120_R01Row, inserted: true }], 0);
				showWarning('데이터가 없습니다.');
			} else {
				ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			}
		} catch (error) {
			console.error('데이터 조회 실패:', error);
			setKSK2120_R01List([]);
		} finally {
			setLoadingSpinner(false);
		}
	
		setKSK2120_R01PastFilter(targetFilter);
		setLoadingSpinner(false);
	}, [
		KSK2120_R01Filter,  KSK2120_R01PastFilter, KSK2120_R01List, deletedKSK2120_R01List,
		gridRef, setMessage, setLoadingSpinner,
		setOriginalKSK2120_R01List, setSelectedKSK2120_R01List, insertKSK2120_R01List,
	]);

	/**
	 * 릴장착정보 목록 조회 함수
	 * 검색 조건에 맞는 릴장착정보 목록을 가져옴
	 */
	const fetchData = useCallback(async (updatedFields?: Partial<KSK2120_R01Filter>) => {
		await executeDataFetch('search', updatedFields);
	}, [executeDataFetch]);

	// 버튼 비활성화 상태 관리
	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,      // 조회: 기본 활성화
		create: false,     // 생성: 기본 활성화
		delete: true,      // 삭제: 기본 비활성화
		save: true,        // 저장: 기본 비활성화
		print: true,       // 출력: 기본 비활성화
		excel: true,       // 엑셀: 기본 비활성화
		init: false        // 초기화: 항상 활성화
	});

	useEffect(() => {
		setButtonDisabled(prev => ({
			...prev,
			delete: deletedKSK2120_R01List.length === 0 && selectedKSK2120_R01List.length === 0,
			save: KSK2120_R01List.length === 0,
			print: KSK2120_R01List.length === 0,
			excel: KSK2120_R01List.length === 0
		}));
	}, [selectedKSK2120_R01List, deletedKSK2120_R01List, KSK2120_R01List]);

	const validateInsertData = (data: KSK2120_R01Dto, currentRowIndex: number) => {
        if (!validateString(data.workplaceCd || '')) { showWarning("작업공정을 선택해주세요."); return false; }
        if (!validateString(data.childItemcd || '')) { showWarning("품목을 선택해주세요."); return false; }
		if (!validateString(data.feederNo || '')) { showWarning("피더번호를 선택해주세요."); return false; }
		// if (!validateString(data.lotNo || '')) { showWarning("장착Lot No를 입력해주세요."); return false; }
		// if (data.lotQty <= 0) { showWarning("수량을 입력해주세요."); return false; }
		// if (validateString(data.remark || '')) { showWarning("완전히 처리되지 않은 실장정보가 있습니다."); return false; }
		
		return true;
	}
	
	//신규 행 추가시 기본적으로 세팅할 데이터를 정하고 생성
	const defaultKSK2120_R01Row = useMemo(() => {

		const workPlaceCdListToUse = workPlaceList.filter(opt => opt.useYn === 'Y' && opt.orderYn === 'Y');

		return {
			...defaultKSK2120_R01Dto,
			compCd: compCdList[0].compCd,
			orderType: ordTypeList[0].minorCd,
			workplaceCd: workPlaceCdListToUse[0].workplaceCd,
			jobTeam: jobTeamList[0].minorCd,
			workProcess: workPlaceCdListToUse[0].workProcess,
			inserted: true
		}
	}, [defaultKSK2120_R01Dto, compCdList, ordTypeList, workPlaceList, jobTeamList]);
	
	const initContainerData = useCallback(() => {
		initData();
	}, [initData]);

	const handleInsertClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
		InsertRowHandler({
			event: e,
			dataList: KSK2120_R01List,
			rowData: {...defaultKSK2120_R01Row, valueIndex: -1},
			insertRow: insertKSK2120_R01List,
			defaultRowData: defaultKSK2120_R01Row,
			setClickable
		});
	}, [KSK2120_R01List, insertKSK2120_R01List, setClickable, defaultKSK2120_R01Row]);

	/**
	 * 삭제 핸들러
	 * 삭제 표시된 행이 있으면 복구, 없으면 선택된 행을 삭제 표시
	 */
	const handleDeleteClick = useCallback(() => {

		let vaild = true;

		if (deletedKSK2120_R01List.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedKSK2120_R01List(deletedKSK2120_R01List);
			removeSelectedKSK2120_R01List();
			setKSK2120_R01List([...originalKSK2120_R01List]);
		} else if (selectedKSK2120_R01List.length > 0) {
			// 삭제 표시된 행이 없으면 선택된 행만 삭제 표시
			addDeletedKSK2120_R01List(selectedKSK2120_R01List);
			removeSelectedKSK2120_R01List(selectedKSK2120_R01List);
		}
	}, [selectedKSK2120_R01List, deletedKSK2120_R01List, addDeletedKSK2120_R01List, removeDeletedKSK2120_R01List, removeSelectedKSK2120_R01List, setKSK2120_R01List, KSK2120_R01List]);
	
	const handleSaveClick = useCallback(async () => {

		// if(!validateString(KSK2120_R01Filter.pastWorkNo || '')) { 
		// 	showWarning("과거 공정지시번호를 선택해주세요.");
		// 	return;
		// }
		if(!validateString(KSK2120_R01Filter.nowWorkNo || '')) { 
			showWarning("현재 공정지시번호를 선택해주세요.");
			return;
		}
		setLoadingSpinner(true);

		// 릴장착정보보 처리
		const patchList: KSK2120_R01Dto[] = KSK2120_R01List.map(item => ({
			...item,
			itemCd: item.childItemcd,
		}));
		
        // 수정 릴장착정보 유효성 검증
		let seenMenuSet = new Set<string>();
		let valid = true;
		for(const value of patchList) {
			if(!validateInsertData(value, value.valueIndex)) { valid = false; setLoadingSpinner(false); return; }
			seenMenuSet.add(value.valueIndex.toString());
		}
		if(!valid) { setLoadingSpinner(false); return; }

		const deleteStringList = deletedKSK2120_R01List.map(item => item.toString());
		//마감여부가 Y인 공정지시는 삭제 불가
		const deleteTargetList = KSK2120_R01List.filter(item => 
			deleteStringList.includes(item.valueIndex.toString())
		);

		const [patchResponse] = await Promise.all([
			patchList.length > 0 ? patchKSK2120_R01(patchList) : Promise.resolve(),
		]);

		if(patchResponse?.data.successFlag) {
			showSuccess('릴장착정보 저장이 완료되었습니다.');
			setMessage('릴장착정보 저장이 완료되었습니다.');
			setTimeout(() => { setMessage(''); }, 5000);
		}
		setTimeout(() => { setMessage(''); }, 5000);

		await executeDataFetch('refetch');
		setLoadingSpinner(false);
		
	}, [KSK2120_R01Filter, KSK2120_R01List, deletedKSK2120_R01List, originalKSK2120_R01List, executeDataFetch]);

	// KSK2010_R01에서 전달받은 데이터로 자동 조회
	useEffect(() => {
		
		if (productMaterialNavigationData) {
			
			// 네비게이션 데이터를 ref에 저장
			navigationDataRef.current = productMaterialNavigationData;

			// KSK2120_R01Filter의 nowWorkNo를 릴장착정보번호로 설정
			setKSK2120_R01Filter({ ...KSK2120_R01Filter, nowWorkNo: productMaterialNavigationData.productWorkNo || '' });
			setProductMaterialTrigger(true);
			
			setProductMaterialNavigationData(null);
		}
	}, [productMaterialNavigationData, setProductMaterialNavigationData]);

	
	//productMaterialTrigger true이면 fetchData를 호출
	useEffect(() => {
		const workNo = navigationDataRef.current?.productWorkNo || '';
		if (productMaterialTrigger && validateString(workNo)) {
			fetchData();
			setProductMaterialTrigger(false);
		}
	}, [productMaterialTrigger]);

	return{
		nowWorkNoHandleFoucsId,
		getProductMaterialFieldHandlers,
		fetchData,
		defaultKSK2120_R01Row,
		initContainerData,
		handleInsertClick,
		handleDeleteClick,
		handleSaveClick,
		buttonDisabled,
	}
}
